import { defineComponent, ref, toRef, reactive, computed, provide, createElementBlock, openBlock, renderSlot } from 'vue';
import { useFocusState } from './basler-components.es442.js';
import { accordionInjectionKey } from './basler-components.es424.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AccordionComponent",
  props: {
    openMultipleItems: { type: Boolean, default: false },
    itemHeadingLevel: { default: 3 },
    state: {}
  },
  emits: ["update:state"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const accordionRef = ref(null);
    const { onElementKeydown } = useFocusState(accordionRef, ".accordion-item__trigger");
    const externalState = toRef(props, "state");
    const internalState = reactive({
      panels: []
    });
    const state = computed(() => {
      return externalState.value ? externalState.value : internalState;
    });
    const hasOpenedItem = computed(() => {
      return Object.values(state.value.panels).some((panel) => panel.isActive);
    });
    const onItemInit = (payload) => {
      const uid = payload.uid || Date.now().toString(36) + Math.random().toString(36).substring(2);
      const itemInState = state.value.panels.find((panel) => panel.uid === uid);
      const canAddOpenedItem = !hasOpenedItem.value || props.openMultipleItems;
      const shouldBeOpenedByDefault = !!payload.openOnInit && canAddOpenedItem;
      const isItemOpened = shouldBeOpenedByDefault || (itemInState ? itemInState.isActive : false);
      if (itemInState) {
        itemInState.isActive = isItemOpened;
      } else {
        state.value.panels.push({ uid, isActive: isItemOpened });
      }
      return {
        uid,
        itemHeadingLevel: props.itemHeadingLevel,
        isItemOpened
      };
    };
    const onTriggerClick = (id) => {
      if (props.openMultipleItems) {
        const panel = state.value.panels.find((panel2) => panel2.uid === id);
        if (panel) {
          panel.isActive = !panel.isActive;
        }
      } else {
        state.value.panels.forEach((panel) => {
          if (panel.uid === id) {
            panel.isActive = !panel.isActive;
          } else {
            panel.isActive = false;
          }
        });
      }
      emit("update:state", state.value);
    };
    provide(accordionInjectionKey, {
      itemInit: onItemInit,
      triggerClick: onTriggerClick,
      triggerKeydown: onElementKeydown,
      accordionListState: state.value.panels
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "accordion",
        ref_key: "accordionRef",
        ref: accordionRef
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 512);
    };
  }
});

export { _sfc_main as default };
